import React from "react";
import { useTranslation } from "react-i18next";
import MainLogoWhite from "components/MainLogoWhite";
import { test } from "utils/helpers";
import "./InterpreterPostCall.scss";

const InterpreterPostCall = () => {
  const { t } = useTranslation();

  return (
    <div
      className="guest-post-call-screen interpreter-post-call"
      {...test("GUEST_POST_SCREEN")}
    >
      <div className="content">
        <MainLogoWhite />
        <div>
          <div tabIndex="0" id="guest-logout-message">
            <h2
              className="guest-logout-message-title"
              {...test("THANKS_FOR_PARTICIPATING_TITLE")}
              dangerouslySetInnerHTML={{
                __html: `${t("THANKS_FOR_PARTICIPATING")}<br>${t(
                  "SESSION_OVER_TEXT"
                )}`,
              }}
            ></h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterpreterPostCall;
